import Vue from 'vue';
import Vuex from 'vuex';


import persons from '@/store/modules/persons';
import globals from '@/store/modules/global';
import fancy from '@/store/modules/fancy';
import admin from '@/store/modules/admin';
import page from '@/store/modules/page';
import refs from '@/store/modules/refs';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    persons,
    globals,
    fancy,
    admin,
    page,
    refs,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js